const context = require.context('./items', false, /\.json$/)

const articles = context
  .keys()
  .sort((a, b) => a.localeCompare(b))
  .map((key) => {
    const module = context(key)
    return module.default || module
  })

export default articles
